export const formatAmount = (amount: number | string): string => {
  const num = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (isNaN(num)) return '0.00';

  return num.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const numberFormat = (amount: string) => {
  return amount
    .replace(/[^0-9.]/g, '') // Allow only numbers and a decimal point
    .replace(/^0+(\d)/, '$1') // Remove leading zeros (but keep a single zero if it's "0" or "0.x")
    .replace(/^(\d*\.)(.*)\./g, '$1$2') // Ensure only one decimal point
    .replace(/\B(?=(\d{3})+(?!\d))/g, ','); // Add commas to the integer part
};
